import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';
import React, { useState, useRef, useEffect } from 'react';
import { Download, SlashIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import useFetch from 'use-http';

export default function CouponDownload({ fileGuids }) {
  const { request: couponDownloadRequest } = useFetch(
    `/CouponManagement/Download`,
  );

  const handleFileDownload = async (fileGuidsLength, file, idx) => {
    await couponDownloadRequest.get(`?fileGuid=${file}`).then((res) => {
      // window.open(res, '_blank');
      var a = document.createElement('a');
      a.href = res;
      a.download =
        fileGuidsLength === 1
          ? 'Affidea dovanų kuponas.pdf'
          : `Affidea dovanų kuponas ${idx + 1}.pdf`;
      setTimeout(() => {
        a.click();
      }, 120);
    });
  };

  return (
    <div>
      <Card>
        <CardHeader>
          <div>
            <Heading variant={'2'}>Sėkmingai įsigijote dovanų kuponą</Heading>
          </div>
          <div>
            <Label></Label>
          </div>
        </CardHeader>
        <CardContent className="flex flex-wrap justify-center items-center gap-2">
          {fileGuids &&
            fileGuids.map((file, idx) => (
              <Button
                key={idx}
                variant="light"
                className="flex items-center gap-2 px-4 py-2"
                onClick={() => handleFileDownload(fileGuids.length, file, idx)}
              >
                <Download />
                Parsisiųsti dovanų kuponą
              </Button>
            ))}
        </CardContent>
        <CardFooter></CardFooter>
      </Card>
    </div>
  );
}
